import React from 'react'

const HomePage = ({history}) => {
  return (
         <div className="ui inverted vertical masthead center aligned segment">
           <div className="ui text container">
             <h1 className="ui inverted stackable header">
               <div className="content">Christian Hub</div>
             </h1>
             <h2>Come and join us !</h2><br/>
             <div onClick={() => history.push('/events')} className="ui huge white inverted button">
               Get Started
               <i className="right arrow icon" />
             </div>
           </div>
         </div>
  )
}

export default HomePage



// WEBPACK FOOTER //
// ./src/features/home/HomePage.jsx